import { EnvVariable, getEnv } from 'lib/helpers/envHelper';
import _ from 'lodash';
import Router from 'next/router';
import { getServerContext } from './serverContext';

export const redirect = async (
  path: string,
  options?: {
    /** The desired locale of the new page. */
    locale?: string;
  }
): Promise<void> => {
  return new Promise(() => {
    const redirectPath = options?.locale ? `/${options.locale}${path}` : path;
    const serverContext = getServerContext();
    console.log('redirecting to: ', redirectPath);
    if (serverContext) {
      // sometimes we have multiple calls that all 401!
      if (!serverContext.res.finished) {
        serverContext.res.writeHead(302, {
          Location: redirectPath,
        });
        serverContext.res.end();
      }
    } else {
      if (
        _.includes(path, getEnv(EnvVariable.API_PATHNAME)) ||
        _.includes(path, 'http')
      ) {
        window.location.href = redirectPath;
      } else {
        console.log('router pushing the url', redirectPath);
        Router.push(redirectPath);
      }
    }
  });
};
